/*
 * @Author: your name
 * @Date: 2020-08-18 16:07:10
 * @LastEditTime: 2022-12-09 13:44:52
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /vuex/src/store/index.js
 */

import { findSameObj, } from '../modules/store'

import getters from './getters'
import dayjs from 'dayjs'
import Vue from 'vue'
import { _ } from 'core-js'
import { CART_SCHEMA_VERSION, CART_SCHEMA_VERSION_KEY } from './cartSchemaVersion'
import { newOrderSeed, seedBelongsToVenue, seedBindingFor } from './orderSeed'
// 没有 import 的纯函数（不经 @/utils/language 绕回 store，不成环）
import { dropMarksOnReAdd, isMenuCategoryLine } from '@/utils/menu/cartMarks'

// Deep copy a copy of data
// 深度 copy 一份数据
const cloneDeep = (data) => {
  return JSON.parse(JSON.stringify(data))
}

const initState = {

  // 购物车形状的版本号。落进 localStorage，恢复时对不上就把存量购物车整个作废
  // （见 `store/cartSchemaVersion.js`）。放在 initState 里是为了 `resetState`
  // 之后它还在 —— 少了它下一次刷新会再清一次购物车。
  [CART_SCHEMA_VERSION_KEY]: CART_SCHEMA_VERSION,

  // Fields required for user to add order interface
  // 用户添加订单接口需要字段
  productList: [],
  expireProductList: [],
  details: {
    comment: '',
    // The orderType here is the real orderType passed to the interface. Its real change depends on the takeaway in locaStorage, but its change depends on the addDetailsProp function in mutation
    // 这里的 orderType 是真实的传给接口的 orderType，他的真正的改变根据 locaStorage 中的 takeaway 决定，但是他的改变取决于 mutation 中的 addDetailsProp 函数
    orderType: 'dine-in',
    table: '',
    surchageRate: 0,
    surchargeAmount: 0
  },
  currency: 'aud',
  type: 0,
  amount: 0,
  discountAmount: 0,
  // Member benefits
  // 会员优惠
  spDiscounts: [],
  // venueId: '', Don't clear venueId
  // venueId: '', 不清空 venueId

  // Table No
  // 桌号
  table: '',

  // Fields required for bank card payment interface
  // 银行卡支付接口时，需要的字段
  paymentInfo: {
    type: 'creditCard',
    transactionId: '123455',
    creditCard: {
      name: '',
      cvc: '',
      expireMonth: '',
      expireYear: '',
      cardNumber: ''
    }
  },

  // Pay first or pay later
  // 先付款还是后付款
  paymentType: '',
  // empty
  // 清空
  navTitle: {
    venueName: '',
    productName: ''
  },
  // VenueUnpaidOrderList The unpaid order of each restaurant is not empty
  // venueUnpaidOrderList：每个餐馆的未付款 order，不清空
  venueUnpaidOrderList: [],

  // SaveIspostPaid is the default payment in advance. This value is the initial value and will be overwritten by the value obtained by get order from the back end
  // saveIspostPaid 默认先付款，这个值为初始值，会被 get-order 从后端获取的值所覆盖
  isPostPaid: false,
  isFromOrderHistoryToOrderDetail: false,
  isFromMenuToStartTab: false,
  isFromStartTabToCardDetails: false,
  isFromMenuToContactDetail: false,
  isCounterPay: false,
  enableTab: false,
  modificationDescSettings: {},
  forceTableInput: false,
  // 「保存到桌面」按店开关（venueInfo.settings.options.enableAddToHomeScreen）。
  // 落进 vuex 是为了让 App.vue 层的抽屉菜单拿到——venue-home 每次加载店铺都会
  // 重新 commit 覆盖，与 forceTableInput 同一模式
  enableAddToHomeScreen: false,
  tipInfo: {
    enableTip: false,
    tipAmount: 0,
    tipRate: 0
  },
  tabInfoList: {
    tabAmount: 0
  },

  // Special parameters to determine whether image is displayed
  // 特殊参数，判断是否显示 image
  showImage: true,
  userPhone: '',
  userCode: '',
  spDiscountsCode: '',
  discountRuleTime: null,

  // A/B test framework: stable per-order seed used for variant assignment.
  // Generated on venue entry, cleared when an order is submitted successfully.
  // A/B 测试框架：用于变体分配的稳定 per-order seed。
  // 进入餐厅时生成，下单成功后清除。
  orderSeed: null,
  currentVenueId: null,
  // 多版本菜单 B6：这家店此刻用哪份菜单（get-menu 带 context 时后端解析出的 resolvedMenu.menuId）。
  // 之后 get-product-list / get-product / 购物车推荐 / 下单都带它；空串 = 没解析（老后端 / 合单）⇒ 一切照今天。
  // 菜单是按 orderSeed 解析的（实验组要 seed 对得上），所以换 seed、下单成功、换店都清它。只存菜单 id，从不存预览码（D80）。
  menuId: '',
  // 多版本菜单 B6（D97）：购物车这几行是在哪份菜单下加的 —— 空车加第一件时记下当时的 menuId。U-B6-2 用它做本地核对。
  cartMenuId: '',
  // QR 扫码临时开关:为真时菜单隐藏酒精并禁止加购;venueId 变更时 resetState() 自动清零
  noAlcohol: false,
}

const store = {
  state: cloneDeep(initState),
  // Except that the state is divided into modules, other mutations and actions are not divided into modules, so pay attention not to duplicate the name when planning!
  // 除了 state 是分模块的，其他 mutations 和 actions 都不分模块，因此规划的时候要注意不要重名！
  mutations: {
    // Initialize state
    // 初始化 state
    resetState(state) {
      for (var i in initState) {
        state[i] = initState[i]
      }
    },

    // Save vuex
    // 保存 vuex
    saveVuex(state, data) {
      _.forEach(data, (item, key) => {
        state[key] = item
      })
    },

    replaceCurrentCart(state, productList) {
      if (productList) state.productList = cloneDeep(productList)
    },

    // Add a new product
    // 添加新的 product
    addNewProductToCart(state, product) {
      // 多版本菜单 B6：空车（不算店家强塞的 disableOperation 行）加第一件 ⇒ 记下建车菜单
      const venueId = product && product.venueId
      const cartHasRows = state.productList.some(item => !item.disableOperation && (venueId === undefined || item.venueId === venueId))
      if (!cartHasRows) state.cartMenuId = state.menuId || ''
      // 多版本菜单 B6（U-B6-2 review 第 1 轮 F2）：从当前菜单的分类里加的这件（菜单上显示它能买）⇒ 撤掉它的「不在菜单上」/「回落拒单」标记，
      // 不然删了再加回来的那一行还是灰的。普通拒单、老标记、缺库存的标记不碰；推荐 / AI / 升级来的行不算
      if (isMenuCategoryLine(product, venueId)) {
        const kept = dropMarksOnReAdd(state.expireProductList, product.id)
        if (kept.length !== (Array.isArray(state.expireProductList) ? state.expireProductList.length : 0)) state.expireProductList = kept
      }
      const index = findSameObj(state.productList, product)
      if (index >= 0) {
        const currentProduct = state.productList[index]
        currentProduct.num = currentProduct.num + product.num
        // If there are combo products, the quantity of the single products should be consistent with that of the combo products
        // 如果有 comboProducts , 则里面的单品数量，要和 combo 的数量一致
        if (currentProduct.comboProducts?.length) {
          currentProduct.comboProducts.forEach(combo => {
            combo.itemList.forEach(item => {
              item.no = currentProduct.num
            })
          })
        }
        state.productList.splice(index, 1, {
          ...product,
          comboProducts: currentProduct.comboProducts,
          num: currentProduct.num,
          recommendFromProductId: currentProduct.recommendFromProductId
        })
      } else {
        // Filter out the disableOperation goods (that is, the cartAddProductList goods)
        // 过滤掉 disableOperation 的商品(也就是 cartAddProductList 的商品)
        let productList = state.productList.filter(item => !item.disableOperation)
        // New products
        // 新增商品
        productList.push({
          ...product
        })
        // Add the goods of cartAddProduct to the end of the self selected goods in the shopping cart
        // 把 cartAddProduct 的商品，添加到购物车的自选商品列表的最后
        productList = productList.concat(state?.venueHome?.cartAddProduct ?? [])
        state.productList = productList
      }
    },

    // Update and edit product information
    // 更新 '编辑商品' 的信息
    updateEditNewProductToCart(state, product) {
      Vue.set(state.productList, product.index, product)
    },

    // Save venueId
    // 保存 venueId
    saveVenueId(state, venueId) {
      state.venueId = venueId
    },

    saveCurrency(state, currency) {
      state.currency = currency.toUpperCase()
    },

    // Save table number
    // 保存桌号
    saveTable(state, table) {
      state.table = table
    },

    // Save the unpaid orderId of each restaurant
    // save 每个餐馆的未付款 orderId
    saveVenueUnpaidOrderList(state, {
      venueId,
      unPaidOrderId,
      unPaidOrderNo
    }) {
      const index = state.venueUnpaidOrderList.findIndex(item => item.venueId === venueId)
      if (index === -1) {
        state.venueUnpaidOrderList.push({
          venueId,
          unPaidOrderId,
          unPaidOrderNo,
        })
      } else {
        state.venueUnpaidOrderList.splice(index, 1, {
          venueId,
          unPaidOrderId,
          unPaidOrderNo,
        })
      }
    },

    // Clear unpaid orderId
    // 清除未付款的 orderId
    // Only one kind of request is allowed. clearUnpaidOrder: pay success
    // 只有 1 种条件下可以 clearUnpaidOrder: pay success
    // 1.card-detail page paysuccess
    // 1.card-detail 页面 paysuccess
    // 2.payment page paysuccess
    // 2.payment 页面 paysuccess
    clearUnpaidOrder(state, venueId) {
      const index = state.venueUnpaidOrderList.findIndex(item => item.venueId === venueId)
      if (index !== -1) {
        state.venueUnpaidOrderList.splice(index, 1)
      }
    },

    // Delete a product
    // 删除一个商品
    deleteGoods(state, {
      product
    }) {
      const currentGoodsIndex = findSameObj(state.productList, product, 'del')
      if (currentGoodsIndex >= 0) {
        state.productList.splice(currentGoodsIndex, 1)
      }
      // Filter out the disableOperation goods (that is, the cartAddProductList goods)
      // 过滤掉 disableOperation 的商品(也就是 cartAddProductList 的商品)
      const productList = state.productList.filter(item => !item.disableOperation)
      // If there is no self selected product, clear the shopping cart
      // 如没有自选商品，就清空购物车
      if (!productList.length) state.productList = []
    },

    // condition
    // 条件
    // 1.pay success
    // 2. post-paid add-order success
    // 3. post-paid create-order success
    clearProductList(state) {
      state.productList = state.productList.filter(item => item.venueId !== state.venueId)
      // Initialize the order type
      // 订单类型，进行初始化
      localStorage.setItem('orderType', '')
      // A/B test: an order finished, drop the seed so the next order gets a fresh one.
      // A/B 测试：订单已完成，清除 seed，下一单会重新生成。
      state.orderSeed = null
      state.currentVenueId = null
      // 多版本菜单 B6：菜单是按这个 seed 解析的，车也没了 —— 两个一起清（`cartSchemaVersion.js` ROOT_CART_KEYS 配对）
      state.menuId = ''
      state.cartMenuId = ''
    },

    // A/B test framework: set the per-order seed bound to a specific venueId.
    // A/B 测试框架：设置绑定到指定 venueId 的 per-order seed。
    SET_ORDER_SEED(state, { seed, venueId }) {
      // 多版本菜单 B6：换了 seed，按旧 seed 解析出的菜单不能再用（实验组菜单要 seed 对得上），等下一次 get-menu
      if (state.orderSeed !== seed) state.menuId = ''
      state.orderSeed = seed
      state.currentVenueId = venueId
    },

    // 多版本菜单 B6：进店前按 url_id 先生成的 seed，get-venue 回来知道 UUID 后改绑 —— seed 值不变
    REBIND_ORDER_SEED(state, venueId) {
      state.currentVenueId = venueId
    },

    // A/B test framework: clear the per-order seed (called on order success).
    // A/B 测试框架：清除 per-order seed（下单成功后调用）。
    CLEAR_ORDER_SEED(state) {
      state.orderSeed = null
      state.currentVenueId = null
      state.menuId = ''
    },

    // 多版本菜单 B6：get-menu 解析出的菜单（只收字符串；空串 = 没有）
    saveMenuId(state, menuId) {
      state.menuId = typeof menuId === 'string' ? menuId : ''
    },

    // 多版本菜单 B6（D97，U-B6-2）：按新菜单本地核对完购物车之后，建车菜单记成这份菜单（utils/menu/menuCheck.js）
    saveCartMenuId(state, menuId) {
      state.cartMenuId = typeof menuId === 'string' ? menuId : ''
    },

    // Xxx from toxxx listens to page jumps, which may be used by multiple pages, so it is temporarily classified as public
    // xxx from toxxx 对页面进行跳转监听。有可能会有多个页面使用，所以暂时归为公共。
    saveIsFromOrderHistoryToOrderDetail(state, res) {
      state.isFromOrderHistoryToOrderDetail = res
    },

    saveIsFromMenuToStartTab(state, res) {
      state.isFromMenuToStartTab = res
    },

    saveIsFromStartTabToCardDetails(state, res) {
      state.isFromStartTabToCardDetails = res
    },

    saveIsFromMenuToContactDetail(state, res) {
      state.isFromMenuToContactDetail = res
    },

    // Save object properties under paymentInfo
    // 储存 paymentInfo 下的对象属性
    savePaymentInfo(state, {
      val,
      prop
    }) {
      state.paymentInfo[prop] = val
    },

    // Add attributes under the details object
    // 添加 details 对象下的属性
    addDetailsProp(state, {
      prop,
      val
    }) {
      state.details[prop] = val
    },
    // Save, pay first or pay later
    // save 先付款还是后付款
    savePaymentType(state, type) {
      state.paymentType = type
    },

    // save Nav Title
    saveNavTitle(state, {
      prop,
      val
    }) {
      state.navTitle[prop] = val
    },

    // Save as pay later
    // 保存是否为后付款的结果
    saveIspostPaid(state, res) {
      state.isPostPaid = res
    },

    // Whether to save as counterPay
    // 保存是否为 counterPay 的结果
    saveIsCounterPay(state, res) {
      state.isCounterPay = res
    },

    // Save tip payment information
    // 保存小费的支付信息
    saveTipInfo(state, {
      prop,
      val
    }) {
      state.tipInfo[prop] = val
    },

    // Save tab information
    // 保存 tab 信息
    saveTabInfo(state, {
      prop,
      val
    }) {
      state.tabInfoList[prop] = val
    },

    // Add creditCardInfo
    // 添加 creditCardInfo
    // Because state PaymentInfo is public and cannot be split into modules
    // 因为 'state.paymentInfo' 是公共的，无法拆分成模块
    saveCreditCardInfo(state, obj) {
      state.paymentInfo.creditCard = obj
    },

    saveEnableTab(state, res) {
      state.enableTab = res
    },

    saveModificationDescSettings(state, res) {
      state.modificationDescSettings = cloneDeep(res)
    },

    // Whether to force table input when saving
    // 保存是否强制 table input 的结果
    saveForceTable(state, obj) {
      state.forceTableInput = obj
    },

    // 「保存到桌面」按店开关，venue-home 加载店铺数据后 commit
    saveEnableAddToHomeScreen(state, enabled) {
      state.enableAddToHomeScreen = !!enabled
    },

    // Add userPhone to restore query history order
    // 添加 userPhone ，用来恢复查询历史订单
    saveUserPhone(state, res) {
      state.userPhone = res
    },

    // Add userPhone to restore query history order
    // 添加 userPhone 用来恢复查询历史订单
    saveUserCode(state, res) {
      state.userCode = res
    },

    // Add expired products
    // 添加过期商品
    saveExpireProductList(state, res) {
      state.expireProductList = res
    },

    saveSpDiscountsCode(state, res) {
      state.spDiscountsCode = res
    },

    saveNoAlcohol(state, v) {
      state.noAlcohol = !!v
    },

    // Clear member offers
    // 清空会员优惠
    clearDiscounts(state) {
      state.discountAmount = 0
      state.spDiscountsCode = ''
      state.discountRuleTime = null
      state.spDiscounts = []
    },

    saveDiscountRuleTime(state) {
      state.discountRuleTime = dayjs().unix()
    },

    // Use member discounts
    // 使用会员优惠
    useMemberRules(state, {
      productList,
      rules,
      server,
      afterDiscountResult,
      code
    }) {
      // check it is server side calculated discount, then just use the records rather than calculated by itself
      if (server === true) {
        const spDiscounts = _serverDiscountRule(rules, productList, afterDiscountResult, code)
        state.spDiscountsCode = code
        state.spDiscounts = spDiscounts
        state.discountAmount = afterDiscountResult.totalDiscount ?? 0
        // console.log(state.spDiscounts)
        return
      }

      // Integrate all types of discount rules into rules array
      // 将所有类型的折扣规则整合到 rules 数组
      // Rules sorting, membership_discount before coupon code
      // rules 排序，membership_discount 在 coupon code 前
      const membershipDiscountList = rules.filter(item => item.name === 'membership_discount')
      const codeOneList = rules.filter(item => item.name === 'coupon code' || (item.type && item.type === 'code'))
      rules = membershipDiscountList.concat(codeOneList)
      // Discount amount
      // 折扣金额
      let discountAmount = 0
      const spDiscounts = []
      // Order amount
      // 订单金额
      let orderAmount = 0
      productList.forEach(item => {
        orderAmount += parseFloat(item.price) * parseFloat(item.num)
      })
      // If there are discount rules, use discounts in turn
      // 若存在折扣规则，则依次使用折扣
      if (rules && rules.length) {
        rules.forEach(rule => {
          let ruleTotalAmount = 0
          // Determine the corresponding calculation method according to the discount name
          // 根据折扣的名称，判断执行对应的运算方法
          if (rule.name === 'membership_discount') {
            ruleTotalAmount = _membershipDiscountRule(rule, productList)
          } else if (rule.name === 'coupon code' || (rule.type && rule.type === 'code')) {
            ruleTotalAmount = _codeDiscounts(rule, productList)
            console.log(ruleTotalAmount)
          }
          if (ruleTotalAmount > orderAmount - discountAmount) {
            ruleTotalAmount = orderAmount - discountAmount
          }
          const data = {
            name: rule.name,
            code,
            rateType: rule.rateType,
            amount: rule.amount,
            applyEach: rule.applyEach,
            totalAmount: ruleTotalAmount,
            type: rule.type ?? 'code'
          }
          if (rule.campaign) data.campaign = rule.campaign
          if (data.totalAmount) spDiscounts.push(data)
          discountAmount += ruleTotalAmount
        })
      }
      state.spDiscountsCode = code
      state.spDiscounts = spDiscounts
      state.discountAmount = discountAmount
    },

    saveShowImage(state, obj) {
      state.showImage = obj
    }
  },
  actions: {
    /**
     * A/B test framework: ensure an orderSeed exists for the current venue.
     * Generates a new seed when entering a different venue or when missing.
     * Must be called before the first menu/product API call so requests carry X-Order-Seed.
     * A/B 测试框架：确保当前餐厅存在 orderSeed。
     * 进入新的餐厅或 seed 缺失时生成新值，必须在第一次拉取 menu/product 接口前调用。
     *
     * `venueId` 是路由参数，可能是 UUID 也可能是 url_id：同一家店的 url_id 认作同一家，不换 seed（B6）。
     * 真正绑到 UUID 在 get-venue 的响应里（`bindOrderSeedToVenue`，见 `store/venueEntry.js`）。
     */
    ensureOrderSeed({ state, commit }, { venueId }) {
      if (!venueId) return null
      if (!seedBelongsToVenue(state, venueId)) {
        commit('SET_ORDER_SEED', { seed: newOrderSeed(), venueId })
      }
      return state.orderSeed
    },

    /**
     * 多版本菜单 B6：get-venue 回来（换店的 resetState 之后）把 seed 绑到这家店的 UUID —— 第一个菜单请求之前 seed 一定在，
     * 而且就是这一单下单会用的那一个。见 `store/orderSeed.js seedBindingFor`。
     */
    bindOrderSeedToVenue({ state, commit }, { venueId, urlId }) {
      if (!venueId) return null
      const binding = seedBindingFor(state, { venueId, urlId })
      if (binding === 'rebind') commit('REBIND_ORDER_SEED', venueId)
      else if (binding === 'new') commit('SET_ORDER_SEED', { seed: newOrderSeed(), venueId })
      return state.orderSeed
    },

    /**
     * A/B test framework: explicit clear (also called automatically from clearProductList).
     * A/B 测试框架：显式清除（clearProductList 也会自动清除）。
     */
    clearOrderSeed({ commit }) {
      commit('CLEAR_ORDER_SEED')
    },
  },
  getters,
}

function _serverDiscountRule(rules, productList, afterDiscountResult, code) {
  const spDiscounts = []
  if (rules && rules.length) {
    rules.forEach((rule, key) => {
      const data = {
        name: rule.name,
        code,
        rateType: rule.rateType,
        amount: rule.amount,
        applyEach: rule.applyEach,
        totalAmount: afterDiscountResult.rules[key].totalDiscount ?? 0,
        type: rule.type ?? 'code'
      }
      if (rule.campaign) data.campaign = rule.campaign
      if (data.totalAmount) spDiscounts.push(data)
    }
    )
  }
  return spDiscounts
}

// Using membership_discount offer
// 使用 membership_discount 优惠
function _membershipDiscountRule(rule, productList) {
  let totalAmount = 0
  // Total price
  // 总价
  const totalPrice = productList.reduce((total, prev) => {
    if (prev.realProductPrice) {
      return total + prev.realProductPrice * prev.num
    } else {
      return total + prev.price * prev.num
    }
  }, 0)
  const ruleAmount = Number(rule.amount)
  const checkExclude = function (product, rule) {
    let exclude = false
    if (rule.excludeId && rule.excludeType) {
      if (rule.excludeType === 'venue_product_group' && rule.excludeId === product.productGroupId) {
        exclude = true
      } else if (rule.excludeId === product.id) {
        exclude = true
      }
    }
    return exclude
  }
  if (rule.rateType === 'dollar') {
    // When it is true, each one should have a discount
    // 为 true 时，每一个都要优惠
    if (rule.applyEach) {
      productList.forEach(product => {
        if (!checkExclude(product, rule)) {
          product.price -= ruleAmount
          if (product.price < 0) {
            product.price = 0
            totalAmount += (product.price * product.num)
          } else {
            totalAmount += (ruleAmount * product.num)
          }
        }
      })
    } else {
      // Judge whether the preferential amount exceeds the total price
      // 判断优惠金额是否超过总价
      if (totalPrice < ruleAmount) {
        totalAmount += totalPrice
      } else {
        totalAmount += ruleAmount
      }
    }
  } else if (rule.rateType === 'percentage') {
    totalAmount = totalPrice * ruleAmount / 100
    productList.forEach(product => {
      if (!checkExclude(product, rule)) {
        product.price -= product.price * ruleAmount / 100
        if (product.price < 0) product.price = 0
      }
    })
  }
  return totalAmount
}

/**
 * check pass min req amount
 * @param amount
 * @param orderItems
 * @param ruleDef
 * @returns {boolean}
 * @private
 */
function _passMinReqAmount(amount, orderItems, ruleDef) {
  amount = parseFloat(amount)
  if (amount <= 0) {
    return true
  }
  let rawCost = 0

  if (ruleDef.nameType === 'xy') { // When the discount type is xy   // 折扣类型是 xy 时
    // Filter only qualified products
    // 过滤只符合条件的商品
    const productList = orderItems.filter(item => {
      const reqItemIdList = []
      const reqItemId = ruleDef?.reqItemId ?? []
      reqItemId.forEach(reqItem => {
        if (Array.isArray(reqItem.id)) {
          reqItem.id.forEach(id => {
            reqItemIdList.push(id)
          })
        } else {
          reqItemIdList.push(reqItem.id)
        }
      })
      return reqItemIdList.find(reqItemId => reqItemId === item.id)
    })
    // Calculate the total price of qualified goods
    // 计算符合条件商品的总价
    productList.forEach(item => {
      rawCost += parseFloat(item.price) * parseFloat(item.num)
    })
  } else { // When the discount type is not xy   // 折扣类型不是 xy 时
    orderItems.forEach(item => {
      rawCost += parseFloat(item.price) * parseFloat(item.num)
    })
  }

  if (rawCost >= amount) {
    return true
  } else {
    return false
  }
}

/**
 * Check No Req
 * @param noOfUse
 * @param noOfUsed
 * @returns {boolean}
 * @private
 */
function _passNoReq(noOfUse, noOfUsed) {
  if (noOfUse < 0) {
    return true
  }

  if (noOfUsed < noOfUse) {
    return true
  }
  return false
}

/**
 * Pass Item Req
 * @param rule
 * @param orderItems
 * @returns {boolean|number}
 * @private
 */
function _passItemReq(rule, orderItems) {
  let checkList = (typeof rule.reqItemId === 'string') ? [rule.reqItemId] : rule.reqItemId
  if (!Array.isArray(checkList) || checkList.length <= 0 || !rule.reqItemId) {
    return true
  }
  checkList = checkList.map(check => {
    return typeof check === 'string' ? {
      id: check,
      type: rule.reqItemType
    } : check
  })

  let orderItemNumber = 0 // 记录商品的数量
  orderItems.forEach(orderItem => {
    for (const [key, checkItem] of checkList.entries()) {
      // just cal once, reload every time
      console.log(checkList)
      let checkType, checkItemIdList, excludeFind
      if (!checkList[key].checkType) {
        checkType = checkItem.type ? checkItem.type : rule.reqItemType
        checkList[key].checkType = checkType
      } else {
        checkType = checkList[key].checkType
      }
      if (!checkList[key].checkItemIdList) {
        checkItemIdList = checkItem.id ? checkItem.id : checkItem
        if (!Array.isArray(checkItemIdList)) {
          checkItemIdList = [checkItemIdList]
        }
        checkList[key].checkItemIdList = checkItemIdList
      } else {
        checkItemIdList = checkList[key].checkItemIdList
      }
      if (orderItem.selectSize && Array.isArray(checkItem.excludeSize)) {
        excludeFind = false
        checkItem.excludeSize.every(excludeItem => {
          const tempName = excludeItem.name ? excludeItem.name : excludeItem
          if (orderItem.selectSize.name && orderItem.selectSize.name.toLowerCase().includes(tempName.toLowerCase())) {
            excludeFind = true
            return true
          }
          return false
        })
        if (excludeFind) {
          continue // detect exclude size, and go to next item
        }
      }
      // console.log('check exist:' + checkType)
      let isPassItemId = false
      if (Array.isArray(checkItemIdList)) {
        isPassItemId = checkItemIdList.findIndex(checkItemId => checkItemId.includes(orderItem.id)) > -1
      } else {
        isPassItemId = checkItemIdList.includes(orderItem.id)
      }

      if (checkType === 'venue_product' && isPassItemId) {
        if (!checkList[key].matchItem) checkList[key].matchItem = []
        const num = _getProductNum(orderItems, orderItem.id, checkList[key])
        if (rule.nameType === 'xy') { // 若是 xy 类型的折扣，将符合条件的商品数量进行累加，数量总和与 minQuantity 做比较
          orderItemNumber += num
        } else {
          orderItemNumber = num
        }
        if (orderItemNumber < checkList[key].minQuantity) return
        checkList[key].matchItem.push(orderItem)
        if ((rule.nameType === 'xy' && Array.isArray(checkList) && checkList.length > 1)) continue
        break // find one rule match, stop loop checking
      } else if (checkType === 'venue_product_group' && checkItemIdList.includes(orderItem.productGroupId)) {
        if (!checkList[key].matchItem) checkList[key].matchItem = []
        if (orderItemNumber < checkList[key].minQuantity) return
        checkList[key].matchItem.push(orderItem)
        break // find one rule match, stop loop checking
      }
    }
  })
  orderItemNumber = 0

  // check all the checkrule has been passed or not
  let maxPass = -1
  for (const [key, checkItem] of checkList.entries()) {
    if (checkItem.matchItem) {
      let tempCount = 0
      checkItem.matchItem.forEach(tempItem => {
        tempCount += parseInt(tempItem.num)
      })
      if (maxPass < 0) {
        maxPass = tempCount
      } else {
        if (maxPass > tempCount) {
          maxPass = tempCount // always use lower value in order to match all the rules
        }
      }
    } else {
      maxPass = 0 // no need to check again, one rule do not match
      break
    }
  }
  return maxPass
}

/**
 * Calculate the total quantity of products
 * @param {Array} productList Shopping Cart Item List
 * @param {String} productId productId
 * @param {Object} rule Discount Rules
 * @returns {Number} Total quantity of goods
 */
/**
 * 计算符合的商品数量总和
 * @param {Array} productList 购物车的商品列表
 * @param {String} productId 条件商品 id
 * @param {Object} rule 折扣规则
 * @returns {Number} 符合的商品数量总和
 */
function _getProductNum(productList, productId, rule) {
  let num = 0
  // Select the products that match the current product ID
  // 挑选出符合当前商品 id 的商品
  const list = productList.filter(item => item.id === productId)
  // Select the discount size rule that matches the current product ID
  // 挑选出符合当前商品 id 的折扣 size 规则
  const sizeList = rule?.excludeSize?.filter(sizeInfo => sizeInfo?.productId ? sizeInfo.productId === productId : true)
  if (sizeList && sizeList.length) {
    // 根据折扣 size 规则，挑选出符合的商品
    list.filter(item => {
      let excludeTempFind = false
      sizeList.every(excludeItem => {
        const tempName = excludeItem.name ? excludeItem.name : excludeItem
        if (item?.selectSize?.name && item.selectSize.name.toLowerCase().includes(tempName.toLowerCase())) {
          excludeTempFind = true
          return true
        }
        return false
      })
      if (excludeTempFind) {
        return false
      } else {
        return true
      }
    })
  }
  if (list.length) {
    // Calculate the total quantity of products
    // 计算符合的商品数量总和
    list.forEach(item => {
      num += Number(item.num)
    })
  }
  return num
}

function _assignDiscount(maxPass, rule, orderItems) {
  const result = {
    success: true,
    amount: 0,
    allAmount: false
  }
  if (maxPass === true) {
    maxPass = 999
  }
  if (rule.applyDiscountQuantityLinkAsReq === true) {
  } else {
    maxPass = 999 // if not apply discount link as quantity, then we will use 999 as max pass.
  }
  if (rule.maxPass && parseInt(rule.maxPass) > 0) {
    maxPass = parseInt(rule.maxPass)
  }

  // check it is apply each or not, if not apply each, just single discount
  if (rule.applyEach === false) {
    result.type = rule.rateType
    rule.amount = parseFloat(rule.amount)
    // eslint-disable-next-line eqeqeq
    if (rule.rateType == 'dollar') {
      result.amount += rule.amount
      // eslint-disable-next-line eqeqeq
    } else if (rule.rateType == 'percentage') {
      result.amount += rule.amount
      // eslint-disable-next-line eqeqeq
    } else if (rule.rateType == 'exact_amount') {
      result.amount = rule.amount
    }
    result.allAmount = true
    return result // stop here, no need to go to further discount info
  }
  let checkList = (typeof rule.itemId === 'string') ? [rule.itemId] : rule.itemId

  if (!Array.isArray(checkList) || checkList.length <= 0 || !rule.reqItemId) {
    return rule
  }

  checkList = checkList.map(check => {
    return typeof check === 'string' ? {
      id: check,
      type: rule.itemType
    } : check
  })

  // Shopping cart items, sorted by price from high to low
  // 购物车商品，按价格从高到低排序
  const orderItemList = orderItems.sort((a, b) => b.price - a.price)

  for (const [key, orderItem] of orderItemList.entries()) {
    for (const [checkKey, checkItem] of checkList.entries()) {
      // just cal once, reload every time
      let checkType, checkItemIdList, excludeFind
      if (!checkList[checkKey].checkType) {
        checkType = checkItem.type ? checkItem.type : rule.itemType
        checkList[checkKey].checkType = checkType
      } else {
        checkType = checkList[checkKey].checkType
      }

      if (!checkList[checkKey].checkItemIdList) {
        checkItemIdList = checkItem.id ? checkItem.id : checkItem
        if (!Array.isArray(checkItemIdList)) {
          checkItemIdList = [checkItemIdList]
        }

        if (Array.isArray(checkItemIdList) && (rule.nameType === 'normal' || rule.nameType === 'bundle')) {
          // Limit discount to one product per order
          const tempList = orderItems.filter(orderItem => {
            // Match commodities matching ID
            // 匹配符合 id 的商品
            if (checkItemIdList.includes(orderItem.id)) {
              // Filter the size list matching the product ID
              // 筛选符合商品 id 的 size 列表
              const sizeList = checkItem.excludeSize.filter(sizeInfo => sizeInfo?.productId ? checkItemIdList.includes(sizeInfo.productId) : true)
              if (sizeList && sizeList.length) {
                // 判断商品的 size 是否在不符合 size 的列表中
                let excludeTempFind = false
                sizeList.every(excludeItem => {
                  const tempName = excludeItem.name ? excludeItem.name : excludeItem
                  if (orderItem?.selectSize?.name && orderItem.selectSize.name.toLowerCase().includes(tempName.toLowerCase())) {
                    excludeTempFind = true
                    return true
                  }
                  return false
                })
                if (excludeTempFind) {
                  return false
                } else {
                  return true
                }
              } else { // 若不存在 size，直接通过
                return true
              }
            }
          }).sort((a, b) => parseFloat(b.price) - parseFloat(a.price))
          checkItemIdList = [tempList[0].id]
        }
        checkList[checkKey].checkItemIdList = checkItemIdList
      } else {
        checkItemIdList = checkList[checkKey].checkItemIdList
      }

      if (!checkList[checkKey].checkRateType) {
        checkList[checkKey].checkRateType = checkItem.rateType ? checkItem.rateType : rule.rateType
      }
      if (!checkList[checkKey].checkAmount) {
        checkList[checkKey].checkAmount = checkItem.amount ? checkItem.amount : rule.amount
      }

      if (orderItem.selectSize && Array.isArray(checkItem.excludeSize)) {
        excludeFind = false
        checkItem.excludeSize.every(excludeItem => {
          const tempName = excludeItem.name ? excludeItem.name : excludeItem
          if (orderItem.selectSize.name && orderItem.selectSize.name.toLowerCase().includes(tempName.toLowerCase())) {
            excludeFind = true
            return true
          }
          return false
        })
        if (excludeFind) {
          continue // detect exclude size, and go to next item
        }
      }
      if ((checkType === 'venue_product' && checkItemIdList.includes(orderItem.id)) ||
        (checkType === 'venue_product_group' && checkItemIdList.includes(orderItem.productGroupId))
      ) {
        if (!checkList[checkKey].matchItem) checkList[checkKey].matchItem = []
        checkList[checkKey].matchItem.push(key)
        if (!checkList[checkKey].matchQuantity) checkList[checkKey].matchQuantity = 0
        checkList[checkKey].matchQuantity += parseInt(orderItem.num)
        break // find one rule match, stop loop checking
      }
    }
  }

  // now select which one can apply discount - the highest one will start to discount
  checkList.forEach(checkItem => {
    let tempPass = parseInt(maxPass)
    if (checkItem.matchItem) {
      if (parseInt(checkItem.matchQuantity) <= tempPass) {
        // easy: every one get discount
        const assignItemDiscountCheckItem = JSON.parse(JSON.stringify(checkItem))
        try {
          checkItem.matchItem.forEach(checkKey => {
            result.amount += _assignItemDiscount(rule, orderItems[checkKey], assignItemDiscountCheckItem, tempPass)
            // When nameType is normal or bundle, when Limit discount to one product per order is enabled, the cycle is terminated after one product is discounted
            // nameType 是 normal 或 bundle 时，开启 Limit discount to one product per order 时，折扣一个商品后，终止循环
            if (
              rule.itemId.length === 1 &&
              Array.isArray(rule.itemId[0].id) &&
              (rule.nameType === 'normal' || rule.nameType === 'bundle') &&
              result.amount > 0
            ) {
              throw new Error('stop')
            }
          })
        } catch (error) {
        }
      } else {
        // now, we need to sort and find out the highest amount orders
        const tempList = []
        checkItem.matchItem.forEach(checkKey => {
          tempList.push({
            data: orderItems[checkKey],
            key: checkKey
          })
        })
        tempList.sort((a, b) => {
          a = a.data ? a.data : {}
          b = b.data ? b.data : {}
          const aUnitCost = a.num ? (a.realProductPrice ? a.realProductPrice : a.price) : 0
          const bUnitCost = b.num ? (b.realProductPrice ? b.realProductPrice : b.price) : 0
          return bUnitCost - aUnitCost // larger one wil be first
        })
        for (const [tempKey, tempItem] of tempList.entries()) {
          if (tempPass > tempItem.data.num) {
            result.amount += _assignItemDiscount(rule, orderItems[tempItem.key], checkItem)
            tempPass -= tempItem.data.num
          } else {
            result.amount += _assignItemDiscount(rule, orderItems[tempItem.key], checkItem, tempPass)
            tempPass = 0
            if ((rule.nameType === 'xy' && Array.isArray(tempList) && tempList.length > 1)) continue
            break // stop here, no need to apply discount
          }
        }
      }
    }
  })

  return result
}

function _assignItemDiscount(rule, orderItem, itemRule, maxNo = 0) {
  if (itemRule.checkRateType) {
    orderItem.num = parseInt(orderItem.num)
    maxNo = parseInt(maxNo)
    if (orderItem.num <= 0) orderItem.num = 1
    if (maxNo <= 0 || maxNo > orderItem.num) {
      maxNo = orderItem.num
    }
    orderItem.price = parseFloat(orderItem.price)
    itemRule.checkAmount = parseFloat(itemRule.checkAmount)
    const productPrice = orderItem.realProductPrice ? orderItem.realProductPrice : orderItem.price
    // When excludeModifierPrice is true, use base price (without modifier adjustments) for discount calculation
    // 当 excludeModifierPrice 为 true 时，使用基础价格（不含配菜调整价格）计算折扣
    const calcPrice = rule.excludeModifierPrice ? parseFloat(orderItem.price) : productPrice
    switch (itemRule.checkRateType) {
      case 'dollar':
        if (itemRule.checkAmount > calcPrice) {
          orderItem.discountAmount = calcPrice * maxNo
        } else {
          orderItem.discountAmount = itemRule.checkAmount * maxNo
        }
        break
      case 'percentage':
        // When discount is xy type
        // 当折扣是 xy 类型时
        if (rule.nameType === 'xy') {
          // Discount quantity is less than shopping cart product quantity
          // 优惠数量小于购物车商品数量
          if (orderItem.num >= itemRule.minQuantity) {
            maxNo = itemRule.minQuantity
            itemRule.minQuantity -= maxNo
          } else {
            itemRule.minQuantity -= orderItem.num
          }
        }
        orderItem.discountAmount = itemRule.checkAmount / 100 * calcPrice * maxNo
        break
      case 'exact_amount':
        // When discount is xy type
        // 当折扣是 xy 类型时
        if (rule.nameType === 'xy') {
          // Discount quantity is less than shopping cart product quantity
          // 优惠数量小于购物车商品数量
          if (orderItem.num >= itemRule.minQuantity) {
            maxNo = itemRule.minQuantity
            itemRule.minQuantity -= maxNo
          } else {
            itemRule.minQuantity -= orderItem.num
          }
        }
        if (itemRule.checkAmount > calcPrice) {
          orderItem.discountAmount = 0
        } else {
          orderItem.discountAmount = calcPrice * (maxNo) - (itemRule.checkAmount * maxNo)
        }
        break
    }
    // Ensure discount does not exceed total product price 确保折扣金额不超过商品总价
    if (orderItem.discountAmount > productPrice * maxNo) {
      orderItem.discountAmount = productPrice * maxNo
    }
    orderItem.calCost = orderItem.discountAmount ? _roundNumber(productPrice * orderItem.num - orderItem.discountAmount) : _roundNumber(productPrice * orderItem.num)
    orderItem.discountInfo = {
      name: rule.name,
      ruleType: rule.type ? rule.type : '',
      type: itemRule.checkRateType,
      amount: itemRule.checkAmount,
      quantity: maxNo,
      discountAmount: orderItem.discountAmount,
      code: rule.code ? rule.code : '',
    }
    // console.log(orderItem)
    return orderItem.discountAmount
  }
  return 0
}

function _roundNumber(num) {
  num = parseFloat(num)
  return Math.round((num + Number.EPSILON) * 100) / 100
}

// Use code offer
// 使用 code 优惠
function _codeDiscounts(rule, productList) {
  const rules = JSON.parse(JSON.stringify(rule))
  const ruleDef = JSON.parse(JSON.stringify(rule))
  let totalAmount = 0
  rules.amount = Number(rules.amount)
  // check rule is passed or not
  let ruleValid = true
  console.log(ruleDef)
  if (!_passMinReqAmount(parseFloat(ruleDef?.minReqAmount ?? 0), productList, ruleDef)) {
    ruleValid = false
  }
  // console.log('min check' + ruleValid)

  // If perDay is enabled, noOfUse and noOfUsed are not verified
  // 若开启了 perDay，则不校验 noOfUse 和 noOfUsed
  if (!ruleDef?.perDay && !_passNoReq(ruleDef?.noOfUse ?? -1, ruleDef?.noOfUsed ?? -1)) {
    ruleValid = false
  }

  // console.log('pass no check' + ruleValid)

  const itemPassedTime = _passItemReq(ruleDef, productList)
  if (itemPassedTime <= 0) {
    ruleValid = false
  }

  // console.log('item check' + ruleValid + "|" + itemPassedTime)
  if (ruleValid) {
    // cal discount
    const tempResult = _assignDiscount(itemPassedTime, ruleDef, productList)
    totalAmount = parseFloat(tempResult.amount) ?? 0
    if (tempResult?.type === 'percentage' || tempResult?.rateType === 'percentage') {
      let orderAmount = 0
      productList.forEach(item => {
        orderAmount += parseFloat(item.realProductPrice ?? item.price) * parseFloat(item.num)
      })
      if (totalAmount > 0) totalAmount = parseFloat(totalAmount / 100)
      totalAmount = orderAmount * parseFloat(totalAmount)
    }
  }
  return totalAmount
}

export default store
